'use client'

import { useEffect } from 'react'

import ServerError from '@/blocks/components/ui/server-error'

export type ErrorProps = {
  error: Error & { digest?: string }
  reset: () => void
}

export default function Error({ error, reset }: ErrorProps) {
  useEffect(() => {
    if (window.newrelic) {
      window.newrelic.noticeError(error)
    } else {
      console.error(error)
    }
  }, [error])

  return <ServerError reset={reset} />
}
